<script>
// import animationData from "@/components/widgets/qhviklyi.json";
import animationData from "@/components/widgets/tdrtiskw.json";
import Lottie from "@/components/widgets/lottie.vue";

export default {
  data() {
    return {
      defaultOptions: { animationData: animationData },
    };
  },
  components: {Lottie},
  methods: {}
}
</script>

<template>
  <!-- auth-page wrapper -->
  <div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div class="bg-overlay"></div>
    <div class="auth-page-content overflow-hidden pt-lg-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-5">
            <div class="card overflow-hidden">
              <div class="card-body p-4">
                <div class="text-center">
                  <lottie colors="primary:#405189,secondary:#0ab39c" :options="defaultOptions"/>
                  <h1 class="text-primary mb-4">Oops !</h1>
                  <h4 class="text-uppercase">Vous n'etes pas authorisé à accéder à cette ressource</h4>
                  <p class="text-muted mb-4">Vous n'avez pas les droits necessaire</p>
                  <router-link to="/" class="btn btn-success"><i class="mdi mdi-home me-1"></i>Back to home</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>